export const ON_ERROR = "ON_EXCEPTION";
export const ON_SUCCESS = "ON_SUCCESS";
export const ON_WARNING = "ON_WARNING";
export const ON_INFO = "ON_INFO";
export const LOADING_START = "LOADING_START";
export const LOADING_END = "LOADING_END";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const ON_SUCCESS_INSERT_PRENOTAZIONE = "ON_SUCCESS_INSERT_PRENOTAZIONE";
